/*
 * Shared components, services, pipes, etc.
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ComponentsModule } from 'app/shared/components/components.module';
import { DirectivesModule } from 'app/shared/directives/directives.module';
import { PipesModule } from 'app/shared/pipes/pipes.module';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    FormsModule,
    ComponentsModule,
    DirectivesModule
  ],
  exports: [
    ComponentsModule,
    DirectivesModule,
    PipesModule,
  ],
})
export class SharedModule {}
